import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { CountdownTimer } from './PricingSection';
export function FinalCtaSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative overflow-hidden" data-id="element-66">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full bg-blue-600/10 blur-[100px] rounded-full pointer-events-none" data-id="element-67" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-68">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-69">
          El próximo lunes puede ser diferente.
        </h2>

        <p className="text-xl md:text-2xl text-blue-300 font-medium italic mb-12 max-w-3xl mx-auto" data-id="element-70">
          "El cambio emocional más importante no es el que se ve — es el que se
          construye." 💙
        </p>

        <div className="mb-12" data-id="element-71">
          <p className="text-red-400 font-bold mb-4" data-id="element-72">⏰ EL PRECIO CIERRA EN:</p>
          <CountdownTimer data-id="element-73" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto mb-12" data-id="element-74">
          {/* Standard Pack CTA */}
          <div className="bg-navy-800 border border-navy-700 rounded-2xl p-6 flex flex-col justify-between" data-id="element-75">
            <div data-id="element-76">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-77">
                💙 MEGAPACK MI ESPACIO INTERIOR
              </h3>
              <p className="text-sm text-slate-400 mb-4" data-id="element-78">
                6 Tomos + 6 Bonos · 12 a 18 años
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-79">
                <span className="text-lg text-slate-500 line-through" data-id="element-80">
                  $65.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-81">$19.990</span>
              </div>
            </div>
            <button onClick={() => window.open('https://descargatop.com/cart/51056408396082:1', '_blank')} className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 px-4 rounded-xl transition-colors text-center cursor-pointer" data-id="element-82">
              → QUIERO MI MEGAPACK
            </button>
          </div>

          {/* Master Pack CTA */}
          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-gold-500 rounded-2xl p-6 flex flex-col justify-between shadow-[0_0_30px_rgba(234,179,8,0.1)]" data-id="element-83">
            <div data-id="element-84">
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-85">
                🏆 MEGAPACK + MASTER-PACK ⭐
              </h3>
              <p className="text-sm text-gold-400 mb-4" data-id="element-86">
                6 Tomos + 6 Bonos + Sistema de Implementación Completo
              </p>
              <div className="flex items-end justify-center gap-2 mb-6" data-id="element-87">
                <span className="text-lg text-slate-500 line-through" data-id="element-88">
                  $95.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-89">$24.990</span>
              </div>
            </div>
            <button onClick={() => window.open('https://descargatop.com/cart/51056409477426:1', '_blank')} className="w-full bg-gradient-to-r from-gold-500 to-yellow-400 hover:from-gold-400 hover:to-yellow-300 text-navy-900 font-bold py-3 px-4 rounded-xl transition-all transform hover:scale-105 text-center cursor-pointer" data-id="element-90">
              → QUIERO EL MEGAPACK COMPLETO
            </button>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400" data-id="element-91">
          <span className="flex items-center gap-2" data-id="element-92">
            <Lock className="w-4 h-4" data-id="element-93" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-94">
            <Shield className="w-4 h-4" data-id="element-95" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-96">
            <CreditCard className="w-4 h-4" data-id="element-97" /> Mercado Pago | Tarjeta
          </span>
        </div>
      </div>
    </section>;
}